<template>
<div class="container container-720">
    <h3>Account</h3>
    <Divider />
    <Form :model="form" label-position="left">
      <FormItem label="Organization Name">
        <Input v-model="form.name" placeholder="" required></Input>
      </FormItem>
      <FormItem>
        <Button v-if="!isSaving" type="primary" @click="saveAccount()" style="float:right;">Save</Button>
        <Button v-if="isSaving" type="primary" style="float:right;">Please wait...</Button>
      </FormItem>
    </Form>
    <div class="managers">
      <h3>Users</h3>
      <Card style="margin-top:30px;">
        <p slot="title">Add new user</p>
        <Form ref="formInline" :model="userForm" inline>
          <FormItem style="width:58%">
            <Input v-model="userForm.email" placeholder="Email">
            </Input>
          </FormItem>
          <FormItem style="width:24%">
            <Select v-model="userForm.role">
                <Option value="manager">Manager</Option>
                <Option value="moderator">Moderator</Option>
            </Select>
          </FormItem>
          <FormItem>
            <Button type="primary" @click="addUser()">Add</Button>
          </FormItem>
        </Form>
      </Card>
      <Table stripe :columns="columns" :data="permissions" style="margin-top:15px;"></Table>
    </div>
</div>
</template>

<script>
import {
  mapActions,
  mapGetters
} from 'vuex';
import _ from 'lodash'

export default {
  data() {
    return {
      form: {},
      userForm: {
        role: "moderator"
      },
      columns:[
        {
          title: 'Name',
          key: 'userName',
          width: 450,
        },
        {
          title: 'Role',
          key: 'role'
        },
        {
          title: 'Action',
          key: 'action',
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                  props: {
                      type: 'error',
                      size: 'small'
                  },
                  on: {
                      click: () => {
                          this.removeUser(params)
                      }
                  }
              }, 'Delete')
            ]);
          }
        },
      ],
      tableData: [],
      isSaving: false,
    }
  },

  computed: {
    ...mapGetters('account', {
      account: 'getCopy'
    }),
    ...mapGetters('user-permissions', {
      findPermissionsInStore: 'find'
    }),
    permissions(){
      return this.findPermissionsInStore({query:{accountId: this.account._id}}).data;
    }
  },
  methods: {
    ...mapActions('account', {
      createAccountAction: 'create',
      updateAccountAction: 'patch',
      getAccountAction: 'get'
    }),
    ...mapActions("users", {
      findUserAction: "find"
    }),
    ...mapActions("user-permissions", {
      createUserPermissionsAction: "create",
      findUserPermissionsAction: "find",
      deleteUserPermissionsAction: "remove",
    }),
    saveAccount(){
      if (this.$route.params.id) {
        this.updateAccount()
      } else {
        this.createAccount()
      }
    },
    updateAccount(){
      this.$set(this.$data, 'isSaving', true)

      this.account.name = this.$data.form.name,

      this.updateAccountAction([this.$route.params.id, this.account]).then(() => {
        this.$set(this.$data, 'isSaving', false)
        this.$Message.success('Account has beed updated')
      })
      .catch((error) => {
        this.$set(this.$data, 'isSaving', false)
        this.$Message.error('Error on account update')
      })
    },
    createAccount() {
      this.$set(this.$data, 'isSaving', true)

      const params = {
        name: this.$data.form.name,
      }

      this.createAccountAction(params).then(() => {
        this.$set(this.$data, 'isSaving', false)
        this.$Message.success('Account has beed created')
        this.$router.replace("/");

      })
      .catch((error) => {
        this.$set(this.$data, 'isSaving', false)
        this.$Message.error('Error on account creation')
      })
    },
    addUser(){
      this.findUserAction({query:{email:this.$data.userForm.email}}).then((userList)=>{
        console.log(userList);
        if(userList.data.length > 0){
          this.createUserPermissionsAction({
            accountId: this.account._id,
            userId: userList.data[0]._id,
            userName: userList.data[0].fullName,
            role: this.userForm.role
          })
        }
      });
    },
    removeUser(params){
      this.deleteUserPermissionsAction(params.row._id);
    }
  },
  created() {
    if (this.$route.params.id) {
      this.getAccountAction(this.$route.params.id).then((account)=>{
        this.$store.commit('account/setCurrent', account._id)
        this.$data.form = _.cloneDeep(this.$store.state.account.copy);
        if(_.has(account, '_id')){
          this.findUserPermissionsAction({query:{
            accountId: account._id
          }})
        }

      });
    }
  },
  mounted() {
    //this.$toastr.defaultPosition = 'toast-top-center'
  }
}
</script>

<style>

</style>
